export default "__VITE_ASSET__BGVMfnPV__"